import React from 'react';

import IconClose from '@pkg/assets/icons/close.svg?react';
import { Filter } from '@pkg/classes';
import { truncateContractAddress } from '@pkg/utils';

import { useNFTsFiltersStore } from '@app/store/zustand';

import { Action, IconWrapper, Label } from './FilterChip.style';

export interface FilterChipProps {
    text: string;
}

export function FilterChip({ text }: FilterChipProps) {
    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();

    const displayValue = text.startsWith('0x') ? truncateContractAddress(text) : text;

    function clearFilter() {
        const currentClone = new Filter(currentFilters);
        currentClone.set(text, []);

        setCurrentFilters(currentClone);
    }

    return (
        <Action ariaLabel={`Click to remove ${text} filter`} onAction={clearFilter}>
            <Label>{displayValue}</Label>

            <IconWrapper>
                <IconClose />
            </IconWrapper>
        </Action>
    );
}
